import EventDatesFormated from 'components/Shared/EventDatesFormated';
import { PreCheckoutDetails, PreCheckoutForm, PreCheckoutLocalStorage, ProductsFields } from 'interfaces/event';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import preCheckoutService from 'services/PreCheckout';
import CreatePreCheckoutService from '../service';
import Timer from '../Timer';
import { Button, Col, Form, Row, Typography, notification } from 'antd';
import { NewForm } from '../Form';
import { prepareRequest } from 'helpers/customFields';

type UrlParams = {
  event_id: string;
  transaction_key: string;
};

const createPreCheckoutService = new CreatePreCheckoutService();

const getCheckoutUrl = (responseUrl, attendances, holderIndex) => {
  const params = new URLSearchParams(window.location.search);
  if (holderIndex !== null) {
    const holder = attendances[holderIndex];

    if (holder) {
      params.set('name', holder.name);
      params.set('doc', holder.document.replace(/\D/g, ''));
      params.set('email', holder.email);
      params.set('phone', holder.phone.replace(/\D/g, ''));
    }
  }

  if (attendances.length === 1) {
    params.append('name', attendances[0].name);
    params.append('doc', attendances[0].document.replace(/\D/g, ''));
    params.append('email', attendances[0].email);
    params.append('phone', attendances[0].phone.replace(/\D/g, ''));
  }

  const paymentUrl = new URL(responseUrl);
  for (const [key, value] of params.entries()) {
    paymentUrl.searchParams.append(key, value);
  }

  return paymentUrl.toString();
};

const Content = () => {
  const [timeOver, setTimeOver] = useState(false);
  const [pageTitle, setPageTitle] = useState('');
  const [pageInstructions, setPageInstructions] = useState('');
  const [eventDetails, setEventDetails] = useState<PreCheckoutDetails | null>(null);
  const [preCheckoutProducts, setPreCheckoutProducts] = useState<ProductsFields[]>([]);
  const [form] = Form.useForm();
  const { event_id, transaction_key } = useParams<UrlParams>();

  const saveDataOnLocalStorage = (products: ProductsFields[]) => {
    const preCheckoutData: PreCheckoutLocalStorage = {
      preCheckoutDetails: eventDetails,
      products,
    };

    createPreCheckoutService.saveDataOnLocalStorage(preCheckoutData);
  };

  const antdFormValues = (products: ProductsFields[]) => {
    const flatFields: Record<string, any> = {};
    products.forEach((product, index) => {
      flatFields[`products-${index}-cnt_cod`] = product.cnt_cod;
      flatFields[`products-${index}-ticket_name`] = product.ticket_name;
      flatFields[`products-${index}-lot_name`] = product.lot_name;
      flatFields[`products-${index}-name`] = product.name || '';
      flatFields[`products-${index}-email`] = product.email || '';
      flatFields[`products-${index}-document`] = product.document || '';
      flatFields[`products-${index}-phone`] = product.phone || '';
    });
    return flatFields;
  };

  useEffect(() => {
    const getDataFromLocalStorage = (details: PreCheckoutDetails): PreCheckoutForm | null => {
      if (createPreCheckoutService.compareDataWithLocalStorage(details)) {
        const local: PreCheckoutLocalStorage = createPreCheckoutService.getDataFromLocalStorage();
        return { products: local.products };
      }
      return null;
    };

    setPageTitle('Carregando');
    setPageInstructions('Obtendo informações do evento. Aguarde...');

    preCheckoutService.details(event_id, transaction_key).subscribe({
      next: response => {
        const details: PreCheckoutDetails = response;
        const localStorageData = getDataFromLocalStorage(details);

        let products: ProductsFields[] = [];

        details.products.forEach((prod, index) => {
          const lotName = prod.lot_name || `Lote ${index + 1}`;
          for (let i = 0; i < prod.quantity; i++) {
            products.push({
              cnt_cod: prod.id,
              ticket_name: prod.name,
              lot_name: lotName,
            });
          }
        });

        if (localStorageData) {
          products = products.map((item, i) => {
            const local = localStorageData.products[i];
            if (local && local.cnt_cod === item.cnt_cod) {
              return { ...item, ...local };
            }
            return item;
          });
        }

        setPreCheckoutProducts(products);
        form.setFieldsValue(antdFormValues(products));
        setPageTitle('Informações dos participantes');
        setPageInstructions(
          'Preencha abaixo as informações dos participantes para cada ingresso comprado. Certifique-se de ter em mãos todos os dados obrigatórios do participante, como nome, e-mail e CPF.',
        );
        setEventDetails(details);
      },
      error: error => {
        console.error(error);
        setPageTitle('');
        setPageInstructions('');

        if (error.response.status !== 404) {
          notification.error({ message: 'Houve uma falha ao obter dados da transação' });
        }

        if (error.response.status === 404) {
          setPageTitle('Prazo Expirado');
          setTimeOver(true);
        }
      },
    });
  }, [event_id, form, transaction_key]);

  const handleTimeOver = () => {
    setTimeOver(true);
    setPageInstructions('');
    setPageTitle('Prazo Expirado');
  };

  const handleFinish = (values: any) => {
    const rawProducts = prepareRequest(values);
    const products = rawProducts.map((product, index) => ({
      ...product,
      cnt_cod: preCheckoutProducts[index].cnt_cod,
    }));

    const formattedValues = {
      ...values,
      products,
    };

    saveDataOnLocalStorage(values);

    preCheckoutService.getSunUrl({ buy: eventDetails.products, cart_id: transaction_key }).subscribe({
      next: response => {
        createPreCheckoutService.createPreCheckout(formattedValues, transaction_key).subscribe({
          next: () => {
            const paymentUrl = getCheckoutUrl(response.payment_url, products, holderIndex);
            window.location.replace(paymentUrl);
          },
          error: (error: any) => {
            console.log(error);
            notification.error({ message: 'Falha ao criar pré checkout' });
          },
        });
      },
      error: (error: any) => {
        console.log(error);
        notification.error({ message: 'Falha ao obter url para pagamento' });
      },
    });
  };

  const [holderIndex, setHolderIndex] = useState<number | null>(null);

  return (
    <div>
      <Row gutter={[15, 15]}>
        <Col span={24}>
          <Typography.Title level={5}>{pageTitle}</Typography.Title>
        </Col>
        <Col span={24}>
          <Typography.Text>{pageInstructions}</Typography.Text>
        </Col>
      </Row>

      <br />

      <Row justify='space-between' gutter={[15, 15]}>
        {!timeOver && eventDetails && (
          <Col xs={24} sm={24} md={12}>
            <Typography.Title level={5}>{eventDetails.event_name || '-'}</Typography.Title>
            <Typography.Text>
              Data do evento: <EventDatesFormated eventDates={eventDetails.event_dates} />
            </Typography.Text>
            <br />
            <Typography.Text>Local do evento: {eventDetails.place || '-'}</Typography.Text>
          </Col>
        )}

        {timeOver && (
          <Col xs={24} sm={24} md={12}>
            <Typography.Title level={5}>O prazo para esta compra expirou</Typography.Title>
          </Col>
        )}

        {!timeOver && eventDetails?.expires_at && (
          <Col xs={24} sm={24} md={12}>
            <Timer date={new Date(eventDetails.expires_at)} timeOver={handleTimeOver} />
          </Col>
        )}
      </Row>

      {!timeOver && preCheckoutProducts.length > 0 && (
        <Form form={form} layout='vertical' size='large' onFinish={handleFinish}>
          {preCheckoutProducts.map((product, index) => (
            <NewForm
              key={index}
              index={index}
              ticketName={product.ticket_name}
              lotName={product.lot_name}
              customFields={eventDetails?.attendance_custom_fields}
              holderIndex={holderIndex}
              setHolderIndex={setHolderIndex}
            />
          ))}

          <Row justify='end'>
            <Col>
              <Form.Item id='submit-form-button' style={{ marginTop: '15px' }}>
                <Button type='primary' htmlType='submit'>
                  Próximo
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      )}
    </div>
  );
};

export default Content;
